<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" flat dense>
        <v-toolbar-title>{{supplier.Name}} - Credit Records</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small text to="/creditors">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>

        <v-row class="subtitle-2 text--primary docForm">

          <v-col cols="12" md="6">
            <v-btn color="primary" to="/make-supplier-payment"> <v-icon left>mdi-plus</v-icon> Record Supplier Payment</v-btn>
          </v-col>

          <v-col cols="12">
            <v-data-table
              :items-per-page="pageItems"
              :headers="headers"
              :items="creditRecords"
              :search="search"
              :mobile-breakpoint="0"
            >
              <!-- template -->
              <template v-slot:item.DocNum="{ item }">
                <v-btn text color="primary" :to="`/goods-receipt/${item.InvoiceId}`">{{item.DocNum}}</v-btn>
              </template>
              <!-- end -->

                <!-- template -->
                <template v-slot:item.DocTotal="{ item }">{{ item.DocTotal | currency }}</template>
              <!-- end -->

               <!-- template -->
               <template v-slot:item.TotalPaid="{ item }">{{ item.TotalPaid | currency }}</template>
              <!-- end -->

              <!-- template -->
              <template v-slot:item.Balance="{ item }">{{ item.Balance | currency }}</template>
              <!-- end -->

              <!-- template -->
                  <template v-slot:item.DocDate="{ item }">{{ item.DocDate | date }}</template>
              <!-- end -->

              <!-- action template -->
              <template v-slot:item.action="{ item }">
                <v-btn text color="accent" @click="openDialog(item)" class="hidden-sm-and-down">
                  <v-icon left>mdi-credit-card-check-outline</v-icon> Receive Payment
                </v-btn>

                <v-btn text color="accent" @click="openPaymentDialog(item)" class="hidden-md-and-up">
                  <v-icon left>mdi-credit-card-check-outline</v-icon> Receive Payment
                </v-btn>
              </template>
              <!-- end -->
            </v-data-table>
            <!-- end -->
          </v-col>

          <!-- <v-col cols="12" v-show="Balance > 0" style="margin-top: -70px">
            <v-btn text color="accent" @click="openDialog">
              <v-icon left>mdi-credit-card-check-outline</v-icon>Record
              Debt Payment
            </v-btn>
          </v-col>-->
        </v-row>
      </v-card-text>
    </v-card>

    <!-- clearing debt dialog -->
    <v-dialog v-model="dialog" max-width="700px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Pay supplier</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row class="subtitle-2 text--primary">
              <v-col cols="6">
                <span
                  style="font-size: 18px"
                >Invoice No: {{selectedInvoice && selectedInvoice.DocNum}}</span>
              </v-col>
              <v-col cols="6">
                <span
                  style="font-size: 18px"
                >Invoice Date: {{selectedInvoice && selectedInvoice.DocDate}}</span>
              </v-col>
              <v-col cols="6">
                <span
                  style="font-size: 18px"
                >Invoice Total: {{selectedInvoice.Balance && selectedInvoice.Balance.toLocaleString()}}</span>
              </v-col>

              <v-col cols="6">
                <DatePicker @date="setDate" :myDate="date" :title="`Date of Payment`"></DatePicker>
              </v-col>

              <v-row class="docForm">
                <v-col cols="12">
                  <v-data-table
                    dense
                    class="p-4"
                    light
                    :headers="paymentHeaders"
                    :items="accounts"
                    hide-default-footer
                  >
                    <template v-slot:item.Name="{ item }">
                      <div style="font-size: 16px; width: 120px">{{ item.Name }}</div>
                    </template>
                    <template v-slot:item.SumApplied="{ item }">
                      <v-text-field
                        type="number"
                        outlined
                        v-model="item.SumApplied"
                        style="width: 220px"
                      ></v-text-field>
                    </template>
                    <template v-slot:item.PaymentRemarks="{ item }">
                      <v-text-field outlined v-model="item.PaymentRemarks" style="width: 300px"></v-text-field>
                    </template>
                  </v-data-table>
                </v-col>

                <v-col cols="12">
                  <span style="font-size: 20px">Total Paid: {{ totalPaid }}</span>
                </v-col>
              </v-row>

              <v-col cols="12">
                <v-btn
                  class="float-right"
                  color="accent"
                  @click="save"
                  :loading="loader"
                >
                  <v-icon left>mdi-content-save</v-icon>Save Payment
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <!-- snackbar -->
        <snackbar ref="snackbar"></snackbar>
      </v-card>
    </v-dialog>
    <!-- end -->

    
        <!-- mobile Payment dialog -->
        <v-dialog v-model="paymentDialog">
          <v-card>
            <v-toolbar dense color="accent" dark>
              <v-toolbar-title>Record Payment</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon @click.native="paymentDialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-container fluid>
                <v-row>
                  <v-col cols="12">
                <span
                  style="font-size: 16px"
                >Invoice No: {{selectedInvoice && selectedInvoice.DocNum}}</span><br>

                <span
                  style="font-size: 16px"
                >Invoice Date: {{selectedInvoice && selectedInvoice.DocDate}}</span><br>

                <span
                  style="font-size: 16px; font-weight: bold"
                >Invoice Total: {{selectedInvoice.Balance && selectedInvoice.Balance.toLocaleString()}}</span><br>
              </v-col>

              <v-col cols="12">
                <DatePicker @date="setDate" :myDate="date" :title="`Date of Payment`"></DatePicker>
              </v-col>


                  <v-col cols="12" xs="12">
                    <v-autocomplete
                      autocomplete="off"
                      hide-details
                      dense
                      outlined
                      v-model="paymentItem.o_a_c_t_s_id"
                      :items="accounts"
                      label="Account"
                      item-text="Name"
                      item-value="id"
                    ></v-autocomplete>
                  </v-col>

                  <v-col cols="12" xs="12">
                    <v-text-field
                      autocomplete="off"
                      type="number"
                      v-model="paymentItem.SumApplied"
                      label="Amount Paid"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" xs="12">
                    <v-text-field
                      autocomplete="off"
                      type="text"
                      v-model="paymentItem.PaymentRemarks"
                      label="Ref / No"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12">
                    <v-btn color="accent" @click="saveMobile" :loading="loader">
                      <v-icon left>mdi-plus</v-icon> Receive Payment
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
          </v-card>
        </v-dialog>
        <!-- end of mobile payment modal-->

    <!-- products modal -->
    <v-dialog v-model="productsDialog" max-width="800px">
      <v-card>
        <v-toolbar dense color="accent" dark>
          <v-toolbar-title>Sold Products</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="productsDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid class="subtitle-2 text--primary">
            <v-row dense id="po">
              <!-- <v-col cols="12" xs="12" md="3">
                <span v-if="record">supplier: {{ record.ocrd && record.ocrd.Name}}</span>
              </v-col>

              <v-col cols="12" xs="12" md="3">Receipt No: {{record.DocNum}}</v-col>

              <v-col cols="12" xs="12" md="3">Date: {{record.DocDate}}</v-col>-->

              <v-col cols="12" id="docForm">
                <v-data-table
                  light
                  :items-per-page="pageItems"
                  :headers="soldHeaders"
                  :items="soldItems"
                  item-key="id"
                  hide-default-footer
                  disable-sort
                  :mobile-breakpoint="0"
                >
                  <template v-slot:item.Name="{ item }">{{item.Name}}</template>

                  <template v-slot:item.Quantity="{ item }">{{item.Quantity}}</template>

                  <template v-slot:item.Price="{ item }">
                    <span v-if="item.Price">{{item.Price.toLocaleString()}}</span>
                  </template>

                  <template v-slot:item.DisplayTotal="{ item }">{{item.DisplayTotal}}</template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of products modal -->

    <!-- Account quick add dialog -->
    <v-dialog v-model="accountDialog" max-width="650px">
      <v-card>
        <v-toolbar dense color="primary" dark>
          <v-toolbar-title>Create Account</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="accountDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <account-editor :initial="accountItem" @data="saveAccount"></account-editor>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end of modal-->

    
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
import AccountEditor from "@/components/subscriber/accounts/_components/quick-editor.vue";
import { http } from "@/common/index";
export default {
  components: {
    AccountEditor
  },
  data() {
    return {
      dialog: false,
      paymentDialog: false,
      paymentItem: {},
      record: {},
      selectedInvoice: {},
      enableCreate: true,
      searchingProduct: false,
      accountDialog: false,
      accountItem: {},
      creditRecords: [],
      productsDialog: false,
      soldItems: [],
      accountId: null,
      supplier: {},
      amount: null,
      accounts: [],
      loader: false,
      search: "",
      pageItems: 100,
      Balance: null,
      date: null,
      headers: [
        { text: "Doc Num", value: "DocNum", align: "left" },
        { text: "Total Sale", value: "DocTotal" },
        { text: "Total Paid", value: "TotalPaid" },
        { text: "Total Returned", value: "TotalReturned" },
        { text: "Balance", value: "Balance" },
        { text: "Date", value: "DocDate" },
        // { text: "Action", value: "action" }
      ],
      soldHeaders: [
        { text: "Product", value: "Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "DisplayTotal" }
      ],
      paymentHeaders: [
        { text: "Account", value: "Name" },
        { text: "Amount", value: "SumApplied" },
        { text: "Ref / Transaction Code", value: "PaymentRemarks" }
      ]
    };
  },
  computed: {
    userName() {
      return localStorage.getItem("userName");
    },
    totalDebtValue() {
      let total = 0;
      if (this.Balance) {
        total = this.Balance.toLocaleString();
      }
      return total;
    },
    newBalance() {
      let amountPaid;
      let newBalance;
      if (this.amount) {
        amountPaid = parseFloat(this.amount);
        newBalance = this.Balance - amountPaid;
      } else {
        amountPaid = 0;
        newBalance = this.Balance - amountPaid;
      }
      return newBalance.toLocaleString();
    },
    mTotalPayments() {
      let total = 0;
      if (typeof this.accounts != "undefined" && this.accounts.length > 0) {
        return this.accounts
          .map(item => {
            let amount = 0;
            if (item.SumApplied) {
              amount = parseFloat(item.SumApplied);
            }

            total = +amount;
            return total;
          })
          .reduce((val, a) => {
            return val + a;
          });
      } else {
        return total;
      }
    },
    totalPaid() {
      return this.mTotalPayments.toLocaleString();
    }
  },
  watch: {
    "$route.params.id": {
      handler: "getRecords",
      immediate: true
    }
  },
  methods: {
    openDialog(invoice) {
      this.selectedInvoice = { ...invoice };
      this.dialog = true;
    },
    openPaymentDialog(invoice) {
      this.selectedInvoice = { ...invoice };
      this.paymentDialog = true;
    },
    setDate(date) {
      this.date = date;
    },
    accountModal() {
      this.accountDialog = true;
    },
    quickAdd(account) {
      this.accounts = [...this.accounts, account];
      this.paymentMode = account.id;
      this.$refs.snackbar.show("Account Added Successully", "green");
    },
    saveAccount(data) {
      const url = "/accounts";
      const self = this;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.quickAdd(res.ResponseData);
            self.loader = false;
            self.accountDialog = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    openProductsModal(val) {
      console.log(val, 'q id');
      const self = this;
      this.$store.commit("loader", true);
      self.record = {};
      this.$store
        .dispatch("get", `/documents/14/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.record = res.ResponseData;
            const products = [];
            if (res.ResponseData.rows) {
              for (const row of res.ResponseData.rows) {
                row.Name = row.product.Name;
                row.DisplayTotal = row.LineTotal.toLocaleString();
                products.push(row);
              }
              self.soldItems = products;
              self.productsDialog = true;
              this.$store.commit("loader", false);
            }
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    async printReceipt(data) {
      const AmountPaid = data.AmountPaid;
      const OutStandingBalance = data.OutStandingBalance;
      const supplierName = data.supplierName;
      const Seller = this.userName;
      await http.post("http://localhost/print/debtor/receipt", {
        AmountPaid,
        OutStandingBalance,
        supplierName,
        Seller
      });
      location.reload();
    },
    save() {
      const self = this;
      if (this.date == null) {
        this.$refs.snackbar.show("Please select date !", "red");
        return;
      }

      if (this.mTotalPayments > this.selectedInvoice.Balance) {
        this.$refs.snackbar.show(
          "You cannot pay more than the invoice total !",
          "red"
        );
        return;
      }

      if (this.mTotalPayments <= 0) {
        this.$refs.snackbar.show("Payments must be greater than 0 !", "red");
        return;
      }

      var tenderPayments = [];
      for (const account of this.accounts) {
        if (account.SumApplied && account.SumApplied > 0) {
          let details = {
            o_a_c_t_s_id: account.id,
            SumApplied: account.SumApplied,
            PaymentRemarks: account.PaymentRemarks,
            PaymentPhone: ""
          };
          tenderPayments.push(details);
        }
      }

      const data = {
        DocDate: self.date,
        totalPaid: this.mTotalPayments,
        invoiceId: this.selectedInvoice.DocEntry,
        payments: tenderPayments
      };
      
      const url = "/pay-specific-debt-invoice";
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
            // self.$router.push("/debtors");
          } else {
            self.$store.commit("btnLoader", false);
          self.loader = false;
          }
        })
        .finally(() => {})
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    saveMobile() {
      console.log(this.paymentItem.o_a_c_t_s_id, ' account id');
      console.log(this.paymentItem.SumApplied, ' amount');
      const self = this;
      if (this.date == null) {
        this.$refs.snackbar.show("Please select date !", "red");
        return;
      }

      if (this.paymentItem.SumApplied == undefined) {
        this.$refs.snackbar.show("Please fill the amount !", "red");
        return;
      }

      if (this.paymentItem.o_a_c_t_s_id == undefined) {
        this.$refs.snackbar.show("Please select an account !", "red");
        return;
      }

      if (this.paymentItem.SumApplied > this.selectedInvoice.Balance) {
        this.$refs.snackbar.show(
          "You cannot pay more than the invoice total !",
          "red"
        );
        return;
      }

    
      var tenderPayments = [];

      let details = {
        o_a_c_t_s_id: this.paymentItem.o_a_c_t_s_id,
        SumApplied: this.paymentItem.SumApplied,
        PaymentRemarks: this.paymentItem.PaymentRemarks,
        PaymentPhone: ""
      };
      tenderPayments.push(details);


      const data = {
        DocDate: self.date,
        totalPaid: this.paymentItem.SumApplied,
        invoiceId: this.selectedInvoice.DocEntry,
        payments: tenderPayments
      };
      
      const url = "/pay-specific-debt-invoice";
      self.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.loader = false;
            location.reload();
            // self.$router.push("/debtors");
          } else {
            self.$store.commit("btnLoader", false);
          self.loader = false;
          }
        })
        .finally(() => {})
        .catch(err => {
          self.$store.commit("btnLoader", false);
          this.$refs.snackbar.show(err, "red");
        });
    },
    getRecords(val) {
      const self = this;
      this.$store
        .dispatch("get", `/creditor-invoices/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.creditRecords = res.ResponseData.unclearedInvoices;
            //  self.Balance = res.ResponseData.Balance;
            self.Balance = res.ResponseData.currentBalance;
            self.supplier = res.ResponseData.supplier;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          console.log(err);
         self.$refs.snackbar.show(err, "red");
        });
    },
    getAccounts() {
      const self = this;
      this.$store
        .dispatch("get", `/bank-accounts`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.accounts = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getAccounts();
  }
};
</script>

<style lang="scss" scoped>
</style>